import {createFileRoute, useParams} from '@tanstack/react-router'
import AssessmentsList from "../../../components/assessments/AssessmentsList.tsx";
import Header from "../../../Header.tsx";
import {useJwtAuth} from "../../../JWTAuthProvider.tsx";

export const Route = createFileRoute('/_app/abilities/')({
    component: RouteComponent,
})

function RouteComponent() {
    const jwt = useJwtAuth();
    const user = jwt.user;
    const params = useParams({strict: false});

    return <>
        <Header backUrl={params.ability_uid ? '/assessments' : undefined} />

        <div className={"max-w-6xl w-11/12 mx-auto"}>
            {!params.ability_uid && <AssessmentsList />}
        </div>
    </>
}
